var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0h-7A1.5 1.5 0 000 1.5v7A1.5 1.5 0 001.5 10h7c.083-.001.165-.01.245-.025l.15-.035H8.955l.185-.07.065-.035c.05-.03.105-.055.155-.09.067-.05.13-.103.19-.16l.035-.045c.05-.05.095-.103.135-.16l.045-.065c.035-.056.066-.114.09-.175a.5.5 0 00.035-.075c.025-.06.04-.125.06-.19V8.8a1.3 1.3 0 00.05-.3v-7A1.5 1.5 0 008.5 0zm-7 9a.5.5 0 01-.5-.5V6.345l1.645-1.65a.5.5 0 01.71 0L7.655 9H1.5zM9 8.5a.5.5 0 01-.035.18.501.501 0 01-.085.13L6.205 6.135l.44-.44a.5.5 0 01.71 0L9 7.345V8.5zm0-2.57L8.06 5a1.54 1.54 0 00-2.12 0l-.44.44L4.06 4a1.54 1.54 0 00-2.12 0L1 4.93V1.5a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v4.43z",
    fill: "#fff"
  })));
}
export default SvgPicture;